import React, {Component} from "react";
import moment from "moment/moment";
import {Col, ControlLabel, Form, FormControl, FormGroup} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import initialData from "../../../../../utilities/initialData/initialData";

export default class SzukajMiesiecznychForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miesiace: [],
            miesiac: null,
            rok: null,
            pesel: '',
            error: null,
            nazwisko: '',
            trasa: null,
        }
        this.onChangeMiesiac = this.onChangeMiesiac.bind(this)
        this.onChangeRok = this.onChangeRok.bind(this)
        this.onChangePesel = this.onChangePesel.bind(this)
        this.onChangeNazwisko = this.onChangeNazwisko.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    };

    componentDidMount() {
        this.initMiesiaceIRok()
    }

    initMiesiaceIRok() {

        let arr = initialData.returnArrayMiesiace()
        arr.push({value: null, label: 'cały rok'})
        this.setState({rok: moment().year(), miesiace: arr, miesiac: arr.find(m => m.value === moment().month() + 1)})
    }

    onChangeMiesiac(e) {
        this.setState({miesiac: e})
    }

    onChangeRok(e) {
        if (e.target.value.length < 5) {
            this.setState({rok: e.target.value})
        }
        else {
            document.getElementById('inputRok').value = this.state.rok
        }
    }

    onChangePesel(e) {
        if (e.target.value.length < 15) {
            this.setState({pesel: e.target.value})
        }
        else {
            document.getElementById('inputPesel').value = this.state.pesel
        }
    }

    onChangeNazwisko(e) {
        this.setState({nazwisko: e.target.value})
    }

    onClickSzukaj() {
        this.setState({error: null})
        if (Boolean(this.state.miesiac && Boolean(this.state.rok))) {
            if (2000 <= this.state.rok && this.state.rok <= 3000) {
                this.props.handleClickSzukaj(this.state.miesiac.value, this.state.rok, this.state.pesel, this.state.nazwisko,this.state.trasa)
            } else this.setState({error: 'Zakres dla roku wynosi od 2000-3000'})
        } else this.setState({error: 'Należy uzupełnić pola miesiac i rok'})
    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup style={{marginBottom: '0'}}>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Miesiac</ControlLabel>
                            <TopSelect onChange={this.onChangeMiesiac} value={this.state.miesiac} options={this.state.miesiace} clearable={false}/>
                        </Col>
                        <Col xs={6} lg={1}>
                            <ControlLabel>Rok</ControlLabel>
                            <FormControl type={'number'} defaultValue={moment().year()} onChange={this.onChangeRok} id={'inputRok'}/>
                        </Col>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Trasa</ControlLabel>
                            <TopSelect onChange={(e)=>this.setState({trasa:e})} value={this.state.trasa} options={this.props.trasy} clearable={true} valueKey={"idTr"} labelKey={"nazTr"}/>
                        </Col>
                        {
                            !this.props.disablePeselAndNazwisko ?
                                <Col xs={6} lg={2}>
                                    <ControlLabel>Pesel</ControlLabel>
                                    <FormControl type={'number'} onChange={this.onChangePesel} id={'inputPesel'}/>
                                </Col>
                                :
                                ''
                        }
                        {
                            !this.props.disablePeselAndNazwisko ?
                                <Col xs={6} lg={2}>
                                    <ControlLabel>Nazwisko</ControlLabel>
                                    <FormControl type={'text'} onChange={this.onChangeNazwisko} id={'inputText'}/>
                                </Col>
                                :
                                ''
                        }
                        <Col xs={6} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Szukaj'} iconType={'fa fa-search'} btnSize={'medium'} onClick={this.onClickSzukaj}/>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.error}>
                                <TopAlertUwaga text={this.state.error}/>
                            </TopIf>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyMiesieczne/components/SzukajMiesiecznychForm.js